import Vue from 'vue'
import App from './App.vue'
import router from './router'


import { Button, Cell, CellGroup, Field, Tabbar, TabbarItem, Toast, Dialog, Icon } from 'vant'
import 'vant/lib/index.css'

Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Icon)

Vue.config.productionTip = false

new Vue({
  router,
 
  render: h => h(App)
}).$mount('#app')